interface SkeletonCellProps {
    /**
     * Allow you to target input by a specific ID during tests
     */
    'data-testid'?: string
}

export default function SkeletonCell({ 'data-testid': dataTestId }: SkeletonCellProps) {
    return (
        <div
            data-testid={dataTestId ?? '__skeleton-cell__'}
            className="skeleton-pulse h-5 w-full rounded-2 not-last-of-type:mb-2"
        />
    )
}
